export const FileMaxSizeInMB = 5;

export const ImageAspectRatio = 36 / 15;

export const CropSettings = {
  aspect: ImageAspectRatio,
  unit: "%",
  width: 100,
};
